import { useState } from "react";

import { useGetPublicBanner } from "@vega-api/generated/banner/banner";

import { ConfigBanner } from "./ConfigBanner";

export const PublicConfigBanner = () => {
  const { data } = useGetPublicBanner({ query: { retry: false } });
  const [dismissedIds, setDismissedIds] = useState<string[]>([]);

  return (
    <ConfigBanner
      banner={data?.data ?? null}
      dismissedIds={dismissedIds}
      onDismiss={(bannerId) =>
        setDismissedIds((previous) => [...previous, bannerId])
      }
    />
  );
};
